import React from 'react';
import { MuiTelInput } from 'mui-tel-input';
import { withParams } from 'providers/ParamsConsumer';
import PropTypes from 'prop-types';

const PhoneNumberField = props => {
  const { params, ...rest } = props;
  return <MuiTelInput defaultCountry={params.countryCode} variant='standard' size='small' fullWidth {...rest} />;
};

PhoneNumberField.propTypes = {
  params: PropTypes.object
};

export default withParams(PhoneNumberField);
